<template>
  <div>
    <CContainer>
      <CRow>
        <CCol md="6">
          <h5 class="mb-4 section-title">My Locations</h5>
        </CCol>
        <CCol v-if="isActiveAutoCheckInModule" md="4">
          <h5 class="mb-4 section-title">Student Check-In PIN</h5>
        </CCol>
      </CRow>
    </CContainer>
    <div>
      <div v-if="userAssignRooms && userAssignRooms.length">
        <div v-for="(room, index) in userAssignRooms" :key="index">
          <div>
            <LocationForm
              :id="room.room_id"
              ref="locationForm"
              :index="index"
              :current-room="room"
              :rooms="rooms"
              @delete-location="handleDeleteLocation(index, room)"
            />
          </div>
        </div>
      </div>
      <div v-for="(room, index) in newLocations" :key="index">
        <LocationForm
          v-if="room && !room.deleted"
          :id="room.room_id"
          ref="locationForm"
          :index="
            userAssignRooms && userAssignRooms.length
              ? index + userAssignRooms.length
              : index
          "
          :rooms="rooms"
          @delete-location="handleDeleteLocation(index)"
        />
      </div>
    </div>
    <div class="p-3">
      <!-- v-if="count < 15"  -->
      <div class="text-center text-md-start">
        <CButton
          class="me-2 p-small bg-gradient-blue reverse"
          @click="addLocation(newLocations.length)"
        >
          <span class="btn bg-white px-4"
            ><b class="text-graident-blue">Add location</b></span
          >
        </CButton>
      </div>
      <CAlert
        v-if="reqResponse.message"
        class="mt-4"
        :color="reqResponse.type"
        :show="!!reqResponse.message"
      >
        {{
          reqResponse.errors != null
            ? "Warning! Same room is selected multiple times"
            : reqResponse.message
        }}
      </CAlert>
      <div
        v-if="count > 0 || (userAssignRooms && userAssignRooms.length)"
        class="form-group form-actions mt-3 text-center"
      >
        <div class="d-inline" @click="submit()">
          <CLoadingButton
            :spinner="isLoading"
            :disabled="isLoading"
            :loading="isLoading"
            class="btn bg-gradient-blue text-white"
          >
            Location Update
          </CLoadingButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import LocationForm from "./LocationForm.vue"
export default {
  name: "AddLocations",
  components: { LocationForm },
  data() {
    return {
      isLoading: false,
      isInvalid: true,
      reqResponse: {
        type: "",
        message: "",
        errors: null
      },
      newLocations: [],
      count: 0,
      renderComponent: true,
      isMounted: false
    }
  },
  computed: {
    ...mapGetters({
      rooms: "rooms/formListRooms",
      userAssignRooms: "rooms/userAssignRooms",
      isActiveAutoCheckInModule: "schools/isActiveAutoCheckInModule"
    })
  },
  created() {
    this.$store.dispatch("rooms/getUserAssignRooms")
  },
  mounted() {
    this.isMounted = true
  },

  methods: {
    submit() {
      if (!this.isMounted) {
        return
      }
      const locationsCollection = []
      this.resetResponseMessages()
      this.isInvalid = false
      this.$refs.locationForm.forEach((form) => {
        form.resetResponseMessages()
        form.touch()
        if (!form.isValid) {
          this.isInvalid = true
        } else {
          if (form.form.location && form.form.location.value) {
            const location = {
              room_id: form.form.location.value.id,
              pin: form.form.pin
            }
            locationsCollection.push(location)
          }
        }
      })
      if (!this.isInvalid) {
        this.assignLocationsToUser(locationsCollection)
      }
    },
    assignLocationsToUser(locations) {
      this.resetResponseMessages()
      this.isLoading = true
      this.$store
        .dispatch("rooms/assignRoomsToUser", { room_ids_and_pins: locations })
        .then(() => {
          this.$store.dispatch("rooms/getUserAssignRooms").then(() => {
            this.newLocations = []
          })
          this.setSuccessResponse("Successfully updated.")
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)

          if (response.data && response.data.id) {
            const pos = this.$refs.locationForm.findIndex((e) => {
              return e.$attrs.id == response.data.id
            })
            const form = this.$refs.locationForm[pos]
            form.reqResponse.errors["teacher_pin"] = response.message
            form.toggleEditable()
          }
        })
    },
    addLocation(index) {
      this.newLocations.push({ index: index })
      this.count++
    },
    handleDeleteLocation(position, room) {
      if (room && room.id) {
        this.deleteAssingLocation(room)
      } else {
        this.newLocations.map((el) => {
          if (el.index == position) {
            el.deleted = true
            this.count--
          }
        })
        this.resetResponseMessages()
      }
    },
    deleteAssingLocation(room) {
      this.$store.dispatch("rooms/deleteAssingRooms", room.room_id)
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: null
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: null
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : null
      }
    }
  }
}
</script>

<style></style>
